module.exports = __webpack_public_path__ + "img/gjng2920_2.e125bd6c.svg";